import { ReactNode, useContext } from 'react';

import { TabValue, TabsContext } from 'shared/providers/TabsProvider';

export interface ITabContentProps {
  children?: ReactNode;
  value: TabValue;
}

export const TabContent = ({ value, children }: ITabContentProps) => {
  const { value: contextValue } = useContext(TabsContext);

  if (contextValue === value) return <>{children}</>;

  return null;
};
